import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export type ButtonType = 'primary' | 'secondary' | 'ghost' | 'primary-brand' | 'secondary-brand';
export type ButtonSize = 'medium' | 'small';

@Component({
  selector: 'c-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, IonicModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: { '[class]': 'hostClass()' },
})
export class ButtonComponent {
  readonly type = input<ButtonType>('primary');
  readonly size = input<ButtonSize>('medium');
  readonly icon = input<IconProp | null>(null);
  readonly iconPosition = input<'start' | 'end'>('end');
  readonly iconOnly = input<boolean>(false);
  readonly ariaLabel = input<string>('');
  readonly disabled = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly fullWidth = input<boolean>(true);

  readonly action = output<void>();

  protected readonly hostClass = computed(() =>
    [
      `c-button--${this.type()}`,
      `c-button--${this.size()}`,
      this.iconOnly() ? 'c-button--icon-only' : '',
      this.loading() ? 'c-button--loading' : '',
      this.fullWidth() && !this.iconOnly() ? 'c-button--full-width' : '',
    ]
      .filter(Boolean)
      .join(' '),
  );

  protected onClick(): void {
    if (this.disabled() || this.loading()) {
      return;
    }

    this.action.emit();
  }
}
